import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { CallSteps } from '../components/contact/CallSteps';
import { CalendlyEmbed } from '../components/contact/CalendlyEmbed';
import { TrustCallouts } from '../components/contact/TrustCallouts';

export default function Contact() {
    return (
        <div data-testid="contact-page">
            <Helmet>
                <title>Contact - White Glove Hiring</title>
                <meta name="description" content="Book a 30-minute diagnostic call with Adam. We look at your current setup, identify leverage gaps, and tell you honestly what we'd recommend." />
                <meta property="og:title" content="Contact White Glove Hiring" />
                <meta property="og:description" content="No pitch. Just a real conversation. 30 minutes. We diagnose your setup and tell you if we're a fit." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/contact`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/contact`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Let's Talk</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight max-w-4xl">
                            No Pitch. Just a Real Conversation.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-2xl leading-relaxed">
                            The diagnostic call is 30 minutes. We look at your current setup, identify where the leverage gaps are, and tell you honestly what we'd recommend - even if it's not us.
                        </p>
                    </motion.div>
                </div>
            </section>

            <CallSteps />
            <CalendlyEmbed />
            <TrustCallouts />
        </div>
    );
}
